import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from 'redux-persist';
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import storage from 'redux-persist/lib/storage';
import { CampaignApi } from "../service/CampaignApi";
import campaignReducer from '../components/features/AddCampaignSlice';
import adsetupReducer from '../components/features/AdSetupSlice';

// ── Per-slice persist configs ─────────────────────────────────────────────────
// adsetup: persist text fields (headlines, body, etc.) but NOT uploaded media.
// uploadedImage / uploadedVideo / audio_queue are transient — they must reset
// on every page refresh so the CMS defaults load fresh from the API.
const adsetupPersistConfig = {
  key: 'adsetup',
  storage,
  keyPrefix: 'nightlife-',
  blacklist: ['uploadedImage', 'uploadedVideo', 'audio_queue', 'audio_index', 'pastedUrl'],
};

// campaign: fully persisted (campaign name, node id, targeting, etc.)
const campaignPersistConfig = {
  key: 'campaign',
  storage,
  keyPrefix: 'nightlife-',
};

const rootReducer = combineReducers({
  [CampaignApi.reducerPath]: CampaignApi.reducer,
  campaign: persistReducer(campaignPersistConfig, campaignReducer),
  adsetup:  persistReducer(adsetupPersistConfig,  adsetupReducer),
});

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(CampaignApi.middleware),
});

export const persister = persistStore(store);

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
